import { useContext, useMemo } from "react";
import { PaginatedTransactionsDataContext } from "../PaginatedTransactionsTable.context";
import { useTransactionsStatisticsQuery } from "../useTransactionsStatisticsQuery";
import { useBulkActions } from "../TransactionsBulkActions/useBulkActions";

export function useFooterPassingStatistics() {
    const { transactions, filters } = useContext(
        PaginatedTransactionsDataContext,
    );
    const { data: statistics } = useTransactionsStatisticsQuery({ filters });
    const bulkActionsCtx = useBulkActions();

    return useMemo(() => {
        if (
            bulkActionsCtx.selectedCount === 0 ||
            bulkActionsCtx.hasSelectedAll
        ) {
            return statistics;
        }

        const selectedStatistics = (transactions ?? []).reduce(
            (agg, transaction) => {
                if (!bulkActionsCtx.isSelected(transaction)) {
                    return agg;
                }

                return {
                    total: agg.total + transaction.amount,
                    cashIn:
                        agg.cashIn +
                        (transaction.amount > 0 ? transaction.amount : 0),
                    cashOut:
                        agg.cashOut +
                        (transaction.amount < 0 ? transaction.amount : 0),
                    averageSum: agg.averageSum + Math.abs(transaction.amount),
                };
            },
            { total: 0, cashIn: 0, cashOut: 0, averageSum: 0 },
        );

        return {
            ...selectedStatistics,
            average:
                selectedStatistics.averageSum / bulkActionsCtx.selectedCount,
            count: bulkActionsCtx.selectedCount,
        };
    }, [bulkActionsCtx, statistics, transactions]);
}
